import { IDropdown } from "../types/IDropdown";


export const Gender: IDropdown[] = [
  { id: 1, title: "Female", value: "F" },
  { id: 2, title: "Male", value: "M" },
];

export const MaritalStatus: IDropdown[] = [
  { id: 1, title: "Married", value: "M" },
  { id: 2, title: "Single", value: "S" },
];

export const AccreditedInvestor: IDropdown[] = [
  { id: 1, title: "Yes", value: "Y" },
  { id: 2, title: "No", value: "N" },
];

export const EmployStatus: IDropdown[] = [
  { id: 1, title: "Home Maker", value: "HM" },
  { id: 2, title: "Self Employed", value: "SE" },
  { id: 3, title: "W2", value: "W2" },
];

export const HouseholdIncome: IDropdown[] = [
  { id: 1, title: "upto $100K", value: "0" },
  { id: 2, title: "$100K to $200K", value: "1" },
  { id: 3, title: "$200K to $300K", value: "2" },
  { id: 4, title: "$300K to $400K", value: "3" },
  { id: 5, title: "$400K to $500K", value: "4" },
  { id: 6, title: "more than $500K", value: "5" },
];

export const ImmigrationStatus: IDropdown[] = [
  { id: 1, title: "F-1", value: "F1" },
  { id: 2, title: "H-1", value: "H1" },
  { id: 3, title: "Green Card", value: "GC" },
  { id: 4, title: "US Citizen", value: "CZ" },
  { id: 5, title: "Non USA Resident", value: "NUR" },
];
